import React from "react";

import PricingPage from "../../pages/PricingPage";
import PackagePricingPage from "../../pages/services/PackagePricingPage";

import { Routes, Route } from "react-router-dom";

function Pricingbar(props) {
  return (
    <Routes>
      <Route path="/pricing" element={<PricingPage props={props} />} />
      <Route path="/package/pricing" element={<PackagePricingPage />} />
    </Routes>
  );
}

export default Pricingbar;
